export default __webpack_public_path__ + "static/media/018-statue.b0b3b3ab.svg";